export const zh = {
  pages: {
    home: {
      title: "主页",
      start: "开始",
    },
    start: {
      title: "一个好的开始",
      subtitle: "选择一个你最喜欢的框架",
      shipping: "配送至荷兰 - ",
      shipping_button: "修改",
      price: "最低",
      continue_button: "继续这一件",
    },
    configure: {
      sideShirtTitle: "体恤衫",
      sideColoursTitle: "颜色",
      sideShirtSubTitle: "选择一个你想让我们折叠并且展示的方式",
      sideColoursSubTitle: "你喜欢的边框颜色以及背景款式是什么？",
    },
  },
};
